import { useMutation } from '@tanstack/react-query'

import API from '../../services/api'

export default function useResetPasswordMutation() {
    return useMutation({ mutationFn: API.resetPassword })
}
